<p-toast></p-toast>
<div class="card mx-5 mt-2 top-desc-card">
  <p-steps [model]="items" [readonly]="true" [(activeIndex)]="activeIndex"></p-steps>
</div>

<div class="stepsdemo-content">
  <form [formGroup]="vendorForm" (ngSubmit)="onSubmit()">
    <p-card *ngIf="activeIndex === 0">
      <ng-template pTemplate="content">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 sub-header">
            <p>Authentication</p>
            <hr class="divider" />
          </div>

          <!-- Email ID Field -->
          <div class="field md:col-3 col-12 valication-status-message">
            <label *ngIf="!isEmailVerified" for="email">Email Id <i class="pi pi-times-circle not-verified">&nbsp;Not
                Verified</i></label>
            <label *ngIf="isEmailVerified" for="email">Email Id <i
                class="pi pi-check-circle verified">&nbsp;Verified</i></label>
            <input [readOnly]="isEmailVerified" id="email" type="email" formControlName="email" pInputText />
            <div *ngIf="(vendorForm.get('email').valid && vendorForm.get('email').touched) && !isEmailVerified"
              class="flex justify-content-left pt-1">
              <a class="clickable" (click)="onClickValidate('email')">{{ 'CLICK_HERE_TO_VERIFY' | translate }}</a>
            </div>
            <div *ngIf="vendorForm.get('email').invalid && vendorForm.get('email').touched" class="error">
              <small *ngIf="vendorForm.get('email').errors?.['pattern']">Only Gmail addresses are allowed.<br></small>
              <small *ngIf="vendorForm.get('email').errors?.['required']">Email is required.</small>
              <small *ngIf="vendorForm.get('email').errors?.['email']">Invalid email format.</small>
            </div>
          </div>

          <!-- Mobile -->
          <div class="field col-12 md:col-3 valication-status-message">
            <label *ngIf="!isMobileVerified" for="mobile">{{ 'MOBILE_NO' | translate }} <i
                class="pi pi-times-circle not-verified">&nbsp;Not Verified</i></label>
            <label *ngIf="isMobileVerified" for="mobile">{{ 'MOBILE_NO' | translate }} <i
                class="pi pi-check-circle verified">&nbsp;Verified</i></label>

            <div>
              <input [readOnly]="isMobileVerified" id="mobile" type="text" formControlName="mobile" pInputText />
            </div>

            <div *ngIf="(vendorForm.get('mobile').valid && vendorForm.get('mobile').touched) && !isMobileVerified"
              class="flex justify-content-left pt-1">
              <a class="clickable" (click)="onClickValidate('mobile')">{{ 'CLICK_HERE_TO_VERIFY' | translate }}</a>
            </div>

            <div *ngIf="vendorForm.get('mobile').invalid && vendorForm.get('mobile').touched" class="invalid-feedback">
              <div *ngIf="vendorForm.get('mobile').errors.required">
                {{ "MOBILE_NO_IS_REQUIRED" | translate }}
              </div>

              <div *ngIf="vendorForm.get('mobile').errors.minlength">
                {{ "MOBILE_NO_SHOULD_BE_OF_10_DIGITS" | translate }}
              </div>
              <div *ngIf="vendorForm.get('mobile').errors.maxlength">
                {{ "MOBILE_NO_SHOULD_BE_OF_10_DIGITS" | translate }}
              </div>
              <div *ngIf="vendorForm.get('mobile').errors.pattern">
                {{ "MBILE_NO_SHOULD_CONTAIN" | translate }}
              </div>
            </div>
          </div>

          <!-- Password Field -->
          <div class="field md:col-3 col-12">
            <label for="password">Password</label>
            <input id="password" type="password" formControlName="password" pInputText />
            <div *ngIf="vendorForm.get('password').invalid && vendorForm.get('password').touched" class="error">
              <small *ngIf="vendorForm.get('password').errors?.['required']">Password is required.</small>
              <small *ngIf="vendorForm.get('password').errors?.['minlength']">Password must be at least 8 characters
                long.</small>
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div class="field md:col-3 col-12">
            <label for="confirmPassword">Confirm Password</label>
            <input id="confirmPassword" type="password" formControlName="confirmPassword" pInputText />
            <div *ngIf="vendorForm.get('confirmPassword').invalid && vendorForm.get('confirmPassword').touched"
              class="error">
              <small *ngIf="vendorForm.get('confirmPassword').errors?.['required']">Confirm Password is
                required.</small>
              <small *ngIf="vendorForm.get('confirmPassword').errors?.['notMatching']">Passwords do not match.</small>
            </div>
          </div>
        </div>
      </ng-template>
    </p-card>

    <p-card *ngIf="activeIndex === 1">
      <!-- <ng-template pTemplate="title">Login and Vendor Details</ng-template>
      <hr class="divider" /> -->
      <ng-template pTemplate="content">
        <div class="p-fluid formgrid grid">

          <div class="field col-12 sub-header">
            <p>{{ "BASIC_INFORMATION" | translate }}</p>
            <hr class="divider" />
          </div>
          <!-- Vendor Type -->
          <div class="field col-12 md:col-2">
            <label for="vendorType">{{ "REGISTRATION_TYPE" | translate }}</label>
            <p-dropdown id="vendorType" [options]="vendorTypes" formControlName="vendorType" optionLabel="Name"
              placeholder="Select Registration Type" (onChange)="onRegTypeChange($event)">
            </p-dropdown>
            <div *ngIf="vendorForm.get('vendorType').invalid && vendorForm.get('vendorType').touched" class="error">
              <small *ngIf="vendorForm.get('vendorType').errors?.['required']">Registration Type is required.</small>
            </div>
          </div>

          <!-- Vendor Supply Management Details -->
          <div class="field col-12 md:col-2">
            <label for="VenSupManDetails1">1. {{ "MANUFACTURER_SUBMANU" | translate }}</label>
            <input id="VenSupManDetails1" type="text" formControlName="VenSupManDetails1" pInputText />
            <div *ngIf="vendorForm.get('VenSupManDetails1').invalid && vendorForm.get('VenSupManDetails1').touched" class="error">
              <small *ngIf="vendorForm.get('VenSupManDetails1').errors?.['required']">This field is required.</small>
            </div>
          </div>

          <div class="field col-12 md:col-2">
            <label for="VenSupManDetails2">2. {{ "MANUFACTURER_SUBMANU" | translate }}</label>
            <input id="VenSupManDetails2" type="text" formControlName="VenSupManDetails2" pInputText />
            <div *ngIf="vendorForm.get('VenSupManDetails2').invalid && vendorForm.get('VenSupManDetails2').touched" class="error">
              <small *ngIf="vendorForm.get('VenSupManDetails2').errors?.['required']">This field is required.</small>
            </div>
          </div>

          <div class="field col-12 md:col-2">
            <label for="VenSupManDetails3">3. {{ "MANUFACTURER_SUBMANU" | translate }}</label>
            <input id="VenSupManDetails3" type="text" formControlName="VenSupManDetails3" pInputText />
            <div *ngIf="vendorForm.get('VenSupManDetails3').invalid && vendorForm.get('VenSupManDetails3').touched" class="error">
              <small *ngIf="vendorForm.get('VenSupManDetails3').errors?.['required']">This field is required.</small>
            </div>
          </div>

          <!-- Vendor Name -->
          <!-- <div class="field col-4">
            <label for="vendorName">Vendor Name</label>
            <input id="vendorName" type="text" formControlName="vendorName" pInputText />
          </div> -->
          <div class="field col-12 md:col-2">
            <label htmlFor="vendorName">{{ "NAME" | translate }}</label>
            <input formControlName="vendorName" pInputText id="vendorName" type="text" [ngClass]="{
              'ng-invalid ng-dirty':
                vendorForm.controls['vendorName'].invalid &&
                vendorForm.controls['vendorName'].touched
            }" />
            <div *ngIf="
              vendorForm.controls['vendorName'].invalid &&
              vendorForm.controls['vendorName'].touched
            " class="invalid-feedback">
              <div *ngIf="vendorForm.controls['vendorName'].errors.required">
                {{ "NAME_IS_REQUIRED" | translate }}
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-2">
            <label for="officialEmailId">{{ "OFFICIAL_EMAIL_ID" | translate }}</label>
            <input id="officialEmailId" type="email" formControlName="officialEmailId" pInputText />
            <div *ngIf="vendorForm.get('officialEmailId').invalid && vendorForm.get('officialEmailId').touched" class="error">
              <small *ngIf="vendorForm.get('officialEmailId').errors?.['required']">Official Email ID is required.</small>
              <small *ngIf="vendorForm.get('officialEmailId').errors?.['email']">Invalid email format.</small>
            </div>
          </div>
          <div class="field col-12 md:col-2">
            <label htmlFor="block">{{ "DATE_OF_INCORPORATION" | translate }}</label>
            <p-calendar [maxDate]="todayDate" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
              formControlName="dob" [ngClass]="{
                'ng-invalid ng-dirty':
                  vendorForm.controls['dob'].invalid &&
                  vendorForm.controls['dob'].touched
              }"></p-calendar>
            <div *ngIf="
                vendorForm.controls['dob'].invalid &&
                vendorForm.controls['dob'].touched
              " class="invalid-feedback">
              <div *ngIf="vendorForm.controls['dob'].errors.required">
                {{ "Date of Incorporation is required" | translate }}
              </div>
            </div>
          </div>
          <!-- <div class="field col-12 md:col-4">
            <label htmlFor="block">{{ "AADHAR_NUMBER" | translate }}</label>
            <input
              maxlength="12"
              formControlName="aadhaar_No"
              pInputText
              id="block"
              type="text"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  vendorForm.controls['aadhaar_No'].invalid &&
                  vendorForm.controls['aadhaar_No'].touched
              }"
            />
            <div
              *ngIf="
                vendorForm.controls['aadhaar_No'].invalid &&
                vendorForm.controls['aadhaar_No'].touched
              "
              class="invalid-feedback"
            >
              <div
                *ngIf="vendorForm.controls['aadhaar_No'].errors.required"
              >
                {{ "AADHAR_NO_IS_REQUIRED" | translate }}
              </div>
              <div
                *ngIf="vendorForm.controls['aadhaar_No'].errors.minlength"
              >
                {{ "AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS" | translate }}
              </div>
              <div
                *ngIf="vendorForm.controls['aadhaar_No'].errors.maxlength"
              >
                {{ "AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS" | translate }}
              </div>
              <div
                *ngIf="vendorForm.controls['aadhaar_No'].errors.pattern"
              >
                {{ "AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS" | translate }}
              </div>
            </div>
          </div> -->

          <!-- GST Number -->
          <!-- <div class="field col-4">
            <label for="gstNumber">GST Number</label>
            <input id="gstNumber" type="text" formControlName="gstNumber" pInputText />
            <div *ngIf="vendorForm.get('gstNumber').invalid && vendorForm.get('gstNumber').touched" class="error">
              <small *ngIf="vendorForm.get('gstNumber').errors?.['pattern']">Invalid GST Number format.</small>
            </div>
          </div> -->
          <div class="field col-12 md:col-2">
            <label htmlFor="vendorName">{{ "GST_NUMBER" | translate }}</label>
            <input formControlName="gstNumber" pInputText id="gstNumber" type="text" [ngClass]="{
                'ng-invalid ng-dirty':
                  vendorForm.controls['gstNumber'].invalid &&
                  vendorForm.controls['gstNumber'].touched
              }" />
            <div *ngIf="
                vendorForm.controls['gstNumber'].invalid &&
                vendorForm.controls['gstNumber'].touched
              " class="invalid-feedback">
              <div *ngIf="vendorForm.controls['gstNumber'].errors.required">
                {{ "GST_NUMBER_IS_REQUIRED" | translate }}
              </div>
              <div *ngIf="vendorForm.controls['gstNumber'].errors.minlength">
                {{ "GST_NO_IS_SHOULD_BE_OF_15_DIGITS" | translate }}
              </div>
              <div *ngIf="vendorForm.controls['gstNumber'].errors.maxlength">
                {{ "GST_NO_IS_SHOULD_BE_OF_15_DIGITS" | translate }}
              </div>
              <div *ngIf="vendorForm.controls['gstNumber'].errors.pattern">
                {{ "INVALID_GST_NO" | translate }}
              </div>
            </div>
          </div>


          <!-- Address -->
          <div class="field col-12 md:col-2">
            <label for="address">{{ "ADDRESS" | translate }}</label>
            <input id="address" type="text" formControlName="address" pInputText />
            <div *ngIf="vendorForm.get('address').invalid && vendorForm.get('address').touched" class="error">
              <small *ngIf="vendorForm.get('address').errors?.['required']">Address is required.</small>
            </div>
          </div>

          <!-- City -->
          <div class="field col-12 md:col-2">
            <label for="city">{{ "CITY" | translate }}</label>
            <input id="city" type="text" formControlName="city" pInputText />
            <div *ngIf="vendorForm.get('city').invalid && vendorForm.get('city').touched" class="error">
              <small *ngIf="vendorForm.get('city').errors?.['required']">City is required.</small>
            </div>
          </div>

          <!-- Country -->
          <div class="field col-12 md:col-2">
            <label for="country">{{ 'COUNTRY' | translate }}</label>
            <p-dropdown id="country" [options]="countries" formControlName="country" optionLabel="name"
              placeholder="{{ 'Select Country' | translate }}" (onChange)="onCountryChange($event)">
            </p-dropdown>
            <div *ngIf="vendorForm.get('country').invalid && vendorForm.get('country').touched" class="error">
              <small *ngIf="vendorForm.get('country').errors?.['country']">Country is required.</small>
            </div>
          </div>

          <!-- State -->
          <!-- <div class="field col-12 md:col-4">
            <label for="state">{{ 'STATE' | translate }}</label>
            <ng-container *ngIf="isIndiaSelected; else stateTextField">
              <p-dropdown id="state" [options]="filteredStates" formControlName="state" optionLabel="filteredStates"
                placeholder="{{ 'SELECT_STATE' | translate }}">
              </p-dropdown>
            </ng-container>
            <ng-template #stateTextField>
              <input id="state" type="text" formControlName="state" pInputText />
            </ng-template>
          </div> -->
          <div class="field col-12 md:col-2">
            <label for="state">{{ 'STATE' | translate }}</label>
            <p-dropdown *ngIf="isIndiaSelected" id="state" [options]="filteredStates" formControlName="state"
              optionLabel="name" optionValue="name" placeholder="{{ 'Select State' | translate }}">
            </p-dropdown>
            <input *ngIf="!isIndiaSelected" id="state" type="text" formControlName="state" pInputText />

            <div *ngIf="vendorForm.get('state').invalid && vendorForm.get('state').touched" class="error">
              <small *ngIf="vendorForm.get('state').errors?.['required']">State is required.</small>
            </div>
          </div>



          <!-- Mobile -->
          <!-- <div class="field col-4">
            <label for="mobile">Mobile</label>
            <input id="mobile" type="text" formControlName="mobile" pInputText />
            <div *ngIf="vendorForm.get('mobile').invalid && vendorForm.get('mobile').touched" class="error">
              <small *ngIf="vendorForm.get('mobile').errors?.['pattern']">Invalid mobile number format.</small>
            </div>
          </div> -->
          <!-- <div class="field col-12 md:col-4">
            <label htmlFor="fatherName">{{ "MOBILE" | translate }}</label>
            <div>
              <input id="mobile" type="text" formControlName="mobile" pInputText />
            </div>
  
            <div
              *ngIf="isSubmitted && vendorForm.get('mobile').errors"
              class="invalid-feedback"
            >
              <div *ngIf="vendorForm.get('mobile').errors.required">
                {{ "MOBILE_NO_IS_REQUIRED" | translate }}
              </div>
  
              <div *ngIf="vendorForm.get('mobile').errors.minlength">
                {{ "MOBILE_NO_SHOULD_BE_OF_10_DIGITS" | translate }}
              </div>
              <div *ngIf="vendorForm.get('mobile').errors.maxlength">
                {{ "MOBILE_NO_SHOULD_BE_OF_10_DIGITS" | translate }}
              </div>
              <div *ngIf="vendorForm.get('mobile').errors.pattern">
                {{ "MBILE_NO_SHOULD_CONTAIN" | translate }}
              </div>
            </div>
          </div> -->



          <div class="field col-12 sub-header-2">
            <p>{{ "BANK_DETAILS" | translate }}</p>
            <hr class="divider" />
          </div>

          <!-- PAN Number -->
          <div class="field col-12 md:col-2">
            <label for="tanNo">TAN Number</label>
            <input id="tanNo" type="text" formControlName="tanNo" pInputText />
            <div *ngIf="vendorForm.get('tanNo').invalid && vendorForm.get('tanNo').touched" class="error">
              <small *ngIf="vendorForm.get('tanNo').errors?.['required']">TAN Number is required.</small>
              <!-- <small *ngIf="vendorForm.get('tanNo').errors?.['pattern']">Invalid TAN Number format.</small> -->
            </div>
          </div>

          <div class="field col-12 md:col-2">
            <label for="panNo">PAN Number</label>
            <input id="panNo" type="text" formControlName="panNo" pInputText />
            <div *ngIf="vendorForm.get('panNo').invalid && vendorForm.get('panNo').touched" class="error">
              <small *ngIf="vendorForm.get('panNo').errors?.['required']">PAN Number is required.</small>
              <small *ngIf="vendorForm.get('panNo').errors?.['pattern']">Invalid PAN Number format.</small>
            </div>
          </div>

          <!-- Bank Account Number -->
          <div class="field col-12 md:col-2">
            <label for="bankAccountNumber">Bank Account Number</label>
            <input id="bankAccountNumber" type="text" formControlName="bankAccountNumber" pInputText />
            <div *ngIf="vendorForm.get('bankAccountNumber').invalid && vendorForm.get('bankAccountNumber').touched"
              class="error">
              <small *ngIf="vendorForm.get('bankAccountNumber').errors?.['required']">Bank Account Number is
                required.</small>
            </div>
          </div>

          <!-- IFSC Code -->
          <div class="field col-12 md:col-2">
            <label for="iFSCCode">IFSC Code</label>
            <input id="iFSCCode" type="text" formControlName="iFSCCode" pInputText />
            <div *ngIf="vendorForm.get('iFSCCode').invalid && vendorForm.get('iFSCCode').touched" class="error">
              <small *ngIf="vendorForm.get('iFSCCode').errors?.['required']">IFSC Code is required.</small>
            </div>
          </div>

          <!-- Bank Name -->
          <!-- <div class="field col-4">
            <label for="bankName">Bank Name</label>
            <input id="bankName" type="text" formControlName="bankName" pInputText />
            <div *ngIf="vendorForm.get('bankName').invalid && vendorForm.get('bankName').touched" class="error">
              <small *ngIf="vendorForm.get('bankName').errors?.['required']">Bank Name is required.</small>
            </div>
          </div> -->
          <div class="field col-12 md:col-2">
            <label for="inventoryStatus">{{ "BANK_NAME" | translate }}</label>
            <p-autoComplete [(ngModel)]="bankAccount.bankName" placeholder="Select Bank Name" id="dd" [dropdown]="true"
              [multiple]="false" appendTo="body" formControlName="bankName" [suggestions]="filteredBankList"
              (completeMethod)="filterBank($event)" field="Bank_NAME" value="BANK_ID"></p-autoComplete>
            <div *ngIf="vendorForm.get('bankName').invalid && vendorForm.get('bankName').touched" class="error">
              <small *ngIf="vendorForm.get('bankName').errors?.['required']">Bank Name is required.</small>
            </div>
          </div>
        </div>
      </ng-template>
    </p-card>

    <p-card *ngIf="activeIndex === 2">
      <ng-template pTemplate="content">
        
        <div class="p-fluid formgrid grid">
          <div class="field col-12 sub-header">
            <p>{{ 'REGISTRATION_FEES' | translate }}</p>
            <hr class="divider" />
          </div>

          <!-- Programme Name -->
          <div class="field col-12 md:col-2">
            <label htmlFor="programme">{{'PROGRAMME_NAME'| translate}}</label>
            <p-multiSelect [options]="programListwithRate" appendTo="body" formControlName="programme"
                placeholder="{{'Select Programme'| translate}}" optionLabel="Program_Name" [showClear]="false" (onChange)="onSelectProg($event)"></p-multiSelect>
              <div *ngIf="vendorForm.get('programme').invalid && vendorForm.get('programme').touched"
                class="error">
                <small *ngIf="vendorForm.get('programme').errors?.['required']">Programme Name is required</small>
              </div>
          </div>

          <!-- DD Amount -->
          <div class="field col-12 md:col-2">
            <label for="ddAmount">{{ "DD_AMOUNT"| translate }}</label>
            <input readonly id="ddAmount" type="text" formControlName="ddAmount" pInputText />
            <div *ngIf="vendorForm.get('ddAmount').invalid && vendorForm.get('ddAmount').touched"
              class="error">
              <small *ngIf="vendorForm.get('ddAmount').errors?.['required']">DD Amount</small>
            </div>
          </div>

          <!-- Bank Account Number -->
          <div class="field col-12 md:col-2">
            <label for="ddNumber">{{ "DD_NUMBER"| translate }}</label>
            <input id="ddNumber" type="number" formControlName="ddNumber" pInputText onwheel="this.blur()" />
            <div *ngIf="vendorForm.get('ddNumber').invalid && vendorForm.get('ddNumber').touched"
              class="error">
              <small *ngIf="vendorForm.get('ddNumber').errors?.['required']">DD Number is
                required.</small>
              <small *ngIf="vendorForm.get('ddNumber').errors?.['pattern']">Accept Number only.</small>
            </div>
          </div>

          <!-- DD Bank Name -->
          <div class="field col-12 md:col-2">
            <label for="ddBankName">{{ "BANK_NAME" | translate }}</label>
            <p-autoComplete placeholder="Select DD Bank Name" id="dd" [dropdown]="true"
              [multiple]="false" appendTo="body" formControlName="ddBankName" [suggestions]="filteredBankList"
              (completeMethod)="filterBank($event)" field="Bank_NAME" value="BANK_ID"></p-autoComplete>
            <div *ngIf="vendorForm.get('ddBankName').invalid && vendorForm.get('ddBankName').touched" class="error">
              <small *ngIf="vendorForm.get('ddBankName').errors?.['required']">DD Bank Name is required.</small>
            </div>
          </div>

          <!-- dd date -->
          <div class="field col-12 md:col-2">
            <label htmlFor="block">{{'DD_DATE' | translate}}</label>
            <p-calendar appendTo="body" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                formControlName="ddDate"
                [ngClass]="{ 'ng-invalid ng-dirty': vendorForm.get('ddDate').invalid && vendorForm.get('ddDate').touched && vendorForm.get('ddDate').errors?.['required'] }"></p-calendar>
            <div *ngIf="vendorForm.get('ddDate').invalid && vendorForm.get('ddDate').touched" class="error">
              <small *ngIf="vendorForm.get('ddDate').errors?.['required']">DD Date is required.</small>
            </div>
          </div>

        


          <!-- UPLOAD DOCUMENTS START -->
          <div class="field col-12 sub-header-2">
            <p>{{ "UPLOAD_SUPPORTING_DOCUMENTS" | translate }}</p>
            <hr class="divider" />
          </div>

          <!-- Document Type Dropdown -->
          <div class="field col-12 md:col-4">
            <label for="documentType">Document Type</label>
            <p-dropdown id="documentType" [options]="uploadOptions" formControlName="documentType" optionLabel="DocType"
              placeholder="Select Document Type" [showClear]="true">
            </p-dropdown>
            <div *ngIf="vendorForm.get('documentType').invalid && vendorForm.get('documentType').touched" class="error">
              <small *ngIf="vendorForm.get('documentType').errors?.['required']">Document Type is required.</small>
            </div>
          </div>

          <!-- File Upload -->
          <div class="field col-12 md:col-4">
            <label for="fileUpload">Upload Document</label>
            <p-fileUpload accept=".pdf" #grievanceCopyPath [customUpload]="true"
              [disabled]="!vendorForm.get('documentType').value"
              (uploadHandler)="onUpload($event, 'grievanceCopyPath', grievanceCopyPath)" name="myfile[]" mode="basic"
              [maxFileSize]="5000000" cho   oseLabel="Browse" [auto]="true">
              <!-- <ng-template pTemplate="content">
                  <input type="file" (change)="onFileChange($event)" class="form-control-file">
              </ng-template> -->
            </p-fileUpload>
          </div>

          <div class="field col-12 md:col-12">
            <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
              <div class="document p-fluid p-formgrid grid mt-5" *ngFor="let item of documentList; let i=index">
                <div class="mr-2 px-2 py-2" style="background-color: rgb(195, 231, 218)">
                  <span style="display: flex; justify-content: space-around; min-width: 120px">
                    {{i+1}}.
                    <br>
                    <p style="margin-bottom: 0;" target="_blank" class="mx-4"> {{item.documentType ? item.documentType:
                      item.DocumentType}}</p>
                    <!-- <p style="margin-bottom: 0;" target="_blank"> {{item.name}}</p> -->
                    <i class="pi pi-times cross-icon" style="color: red; cursor: pointer;"
                      (click)="removeCaptureImg(i)"></i>
                  </span>
                  <img *ngIf="isImage(item.attachmentsDoc || item.ImagePath); else pdfTemplate"
                    [src]="item.attachmentsDoc ? item.attachmentsDoc : item.ImagePath"
                    style="max-width: 300px; max-height: 300px; display: block;">
                  <p *ngIf="isImage(item.attachmentsDoc || item.ImagePath)">
                    <a style="cursor: pointer" [href]="item.attachmentsDoc" target="_blank">{{'VIEW_DOC' |
                      translate}}</a>
                  </p>
                  <ng-template #pdfTemplate>
                    <a style="display: flex; justify-content: center; min-width: 120px"
                      [href]="item.attachmentsDoc ? item.attachmentsDoc : item.ImagePath" target="_blank">
                      View PDF
                    </a>
                  </ng-template>
                </div>
                <!-- <div class="description">
                      
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      
    </p-card>


    <!-- Other steps or cards -->
    <div class="card mt-2 lower-desc-card">
      <div class="grid grid-nogutter justify-content-between">
        <p-button label="Previous" icon="pi pi-angle-left" iconPos="left" *ngIf="activeIndex === 1 || activeIndex === 2"
          (click)="prevPage()"></p-button>
        <p-button label="Next" icon="pi pi-angle-right" iconPos="right" *ngIf="activeIndex === 0 || activeIndex === 1"
          (click)="nextPage()"></p-button>
        <!-- (click)="nextPage()" [disabled]="(!isEmailVerified && !isMobileVerified && activeIndex === 0)"></p-button> -->
        <p-button *ngIf="activeIndex === items.length - 1" label="Submit" type="submit"></p-button>
      </div>
    </div>
  </form>
</div>


<p-dialog header="Validate {{ validationType }}" [modal]="true" [(visible)]="openValidationDialog"
  [style]="{ width: '50%' }">
  <div class="p-fluid p-formgrid justify-content-center validation-container" style="display: flex; flex-wrap:wrap">
    <form [formGroup]="otpValidationForm" (ngSubmit)="onSubmitOTP()">
      <div class="field md:col-12 col-12 flex justify-content-center">
        <span class="p-text-secondary block mb-5">{{ otpSentMessage }}</span>
      </div>
      <div class="field md:col-12 col-12">
        <label for="otp">Enter OTP</label>
        <input *ngIf="validationType =='email'" id="otp" type="text" maxlength="4" pattern="\d{4}" pInputText
          formControlName="otp" />
        <input *ngIf="validationType =='mobile'" id="otp" type="text" maxlength="6" pattern="\d{6}" pInputText
          formControlName="otp" />
        <div *ngIf="otpValidationForm.get('otp').invalid && otpValidationForm.get('otp').touched" class="error">
          <small *ngIf="otpValidationForm.get('otp').errors?.['required']">OTP is required.</small>
          <small *ngIf="otpValidationForm.get('otp').errors?.['pattern'] && validationType =='email'">OTP must be a 4
            digit number.</small>
          <small *ngIf="otpValidationForm.get('otp').errors?.['pattern'] && validationType =='mobile'">OTP must be a 6
            digit number.</small>
        </div>
      </div>
      <div class="flex justify-content-end gap-2">
        <button pButton pRipple label="Cancel" class="p-button-danger"
          (onClick)="openValidationDialog = false"></button>
        <button [disabled]="otpValidationForm.invalid" pButton pRipple label="Validate OTP"
          class="p-button-success"></button>
      </div>
    </form>
  </div>
</p-dialog>